import { render, staticRenderFns } from "./MapTableSwitch.vue?vue&type=template&id=7842c9c8&scoped=true&"
import script from "./MapTableSwitch.vue?vue&type=script&lang=js&"
export * from "./MapTableSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MapTableSwitch.vue?vue&type=style&index=0&id=7842c9c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7842c9c8",
  null
  
)

export default component.exports